import * as React from "react";
import { AuthField } from "../AuthField";
import { AuthButton } from "../AuthButton";
import { AuthCardFooter, AuthFooterAction } from "../AuthCardFooter";

type Props = {
  id: string;
  inputRef: React.Ref<HTMLInputElement>;
  code: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  error?: string | null;
  verifying: boolean;
  onCancel: () => void;
};

/** Second factor: the SMS code. Submits the enclosing form. */
export function MfaStep({
  id,
  inputRef,
  code,
  onChange,
  error,
  verifying,
  onCancel
}: Props) {
  return (
    <>
      <div className="flex flex-col gap-5">
        <AuthField
          ref={inputRef}
          id={id}
          label="Verification Code"
          name="verificationCode"
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          placeholder="123456"
          value={code}
          error={error}
          onChange={onChange}
        />

        <AuthButton
          type="submit"
          fullWidth
          forward
          loading={verifying}
          loadingText="Verifying…"
        >
          Verify Code
        </AuthButton>
      </div>

      <AuthCardFooter>
        <AuthFooterAction onClick={onCancel}>Cancel</AuthFooterAction>
      </AuthCardFooter>
    </>
  );
}
